import React from 'react';
import { BasePortalSection } from '../../../shared/components/portal-base/BasePortalSection';
import type { TravelPaymentPortalSectionProps } from '../types/travel-payment';
import type { BasePortalConfig } from '../../../shared/types/portal-base';
import LoginSection from './sections/LoginSection';
import ResetPasswordSection from './sections/ResetPasswordSection';
import DownloadGuideSection from './sections/DownloadGuideSection';

const travelPaymentPortalConfig: BasePortalConfig = {
  theme: 'default',
  sidebarButtons: [
    { id: 'login', label: 'Login', icon: () => null, section: 'login' },
    { id: 'forgot', label: 'Forgot Password?', icon: () => null, section: 'reset-password' },
    { id: 'download', label: 'Download User Guide', icon: () => null, section: 'download-guide' }
  ],
  sections: [
    { id: 'login', component: LoginSection },
    { id: 'reset-password', component: ResetPasswordSection },
    { id: 'download-guide', component: DownloadGuideSection }
  ]
};

export const TravelPaymentPortalSection: React.FC<TravelPaymentPortalSectionProps> = (props) => {
  return <BasePortalSection config={travelPaymentPortalConfig} {...props} />;
};

export default TravelPaymentPortalSection;